import type { NextPage } from 'next'
import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useRef } from 'react'
import Item from '../../components/item/Item'
import Grid from '../../components/grid/Grid'
import ImageQuote from '../../components/imagequote/ImageQuote'
import CustomImage from '../../components/customImage/CustomImage'

import styles from '../../styles/pages/Downloads.module.scss'

import CustomMetaData from '../../components/general/customMetaData/CustomMetaData'

import { GenericPageLayoutProps } from '../../components/general/genericPageLayout/GenericPageLayout'

import { useGlobalContentContext } from '../../context/GlobalContentContext'

import { parseGenericPage } from '../../utils/parsers'
import { getAPI, createMarkup } from '../../utils/helpers'

type Props = {
  downloadCategories: any
} & GenericPageLayoutProps

const Download = (props: Props) => {
  const { setData } = useGlobalContentContext()

  useEffect(() => {
    setData(props.globalData)
  }, [props.globalData, setData])

  return (
    <div className={styles.container}>
      <CustomMetaData
        title={props.originalResponse.meta_title}
        description={props.originalResponse.meta_description}
        image={props.originalResponse.meta_image}
      />

      <div className={styles.main}>
        <section className={styles.contentContainer}>
          <h1
            className={styles.title}
            dangerouslySetInnerHTML={createMarkup(props.originalResponse.title)}
          ></h1>

          <div className={styles.downloadsContainer}>
            <Grid columns={2}>
              {props.downloadCategories.map((category: any, index: number) => (
                <div key={index} className={styles.download}>
                  <Link
                    href={{
                      pathname: '/downloads/[slug]',
                      query: { slug: category.slug },
                    }}
                  >
                    <a>
                      <div className={styles.imageContainer}>
                        <CustomImage
                          src={category}
                          layout="fill"
                          objectFit="cover"
                        />
                      </div>
                      <h2 className={styles.category}>{category.title}</h2>

                      <div className={styles.downloadCount}>
                        {category.download_count} Photos
                      </div>
                    </a>
                  </Link>
                </div>
              ))}
            </Grid>
          </div>
        </section>
      </div>
    </div>
  )
}

export async function getStaticProps() {
  const page: GenericPageLayoutProps = await parseGenericPage(
    `${getAPI()}/downloadspage/`
  )

  const downloadsRequest = await fetch(`${getAPI()}/download-categories/`)
  const downloads = await downloadsRequest.json()

  return {
    props: {
      originalResponse: page.originalResponse,
      downloadCategories: downloads,
      title: page.title,
      globalData: page.globalData,
      meta_title: page.meta_title,
      meta_description: page.meta_description,
    },
    revalidate: NEXTJS_REVALIDATE_PAGE_IN_SECONDS,
  }
}

export const NEXTJS_REVALIDATE_PAGE_IN_SECONDS = 10
export default Download
